import { UploadOutlined } from '@ant-design/icons';
import { Button, Modal, Progress, Upload, UploadProps, message } from 'antd';
import React, { useState } from 'react';
import { UploadModalProps } from '../../libs/types/src';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';


const { Dragger } = Upload;

const maxFileSize = 50 * 1024 * 1024; // 50MB in bytes

const UploadModal: React.FC<UploadModalProps> = ({
    open,
    onCancel,
    onUpload,
    loading
}) => {
    const { uploadProgress } = useSelector((state: RootState) => state.demos);
    const [fileList, setFileList] = useState([]);

    const handleUpload = async () => {
        if (fileList.length === 0) {
            message.error('Please select a file to upload');
            return;
        }

        const file = fileList[0].originFileObj;
        try {
            await onUpload(file);
            handleCancel();
        } catch (error) {
            console.log(error);
        }
    };

    const handleCancel = () => {
        setFileList([]);
        onCancel();
    };

    const uploadProps: UploadProps = {
        name: 'file',
        multiple: false,
        fileList,
        progress: {
            strokeColor: {
                '0%': '#108ee9',
                '100%': '#87d068',
            },
            strokeWidth: 10,
        },
        onChange: (info) => {
            const validFiles = info.fileList.filter(file => { // Filter out files that exceed size limit
                if (file.originFileObj && file.originFileObj.size > maxFileSize) {
                    message.error(`${file.originFileObj.name} exceeds the 50MB file size limit.`);
                    return false;
                }
                return true;
            });
            setFileList(validFiles.slice(-1)); // Keep only the last file
        },
        accept: '.mp4,.avi,.mov,.wmv,.flv,.webm,.3gp,.mpg,.mpeg',
        beforeUpload: (file) => {
            if (file.size > maxFileSize) {
                return false; // Prevent upload
            }
            return true; // Allow upload
        },
    };

    return (
        <Modal
            open={open}
            onCancel={handleCancel}
            title="Upload New Demo"
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button
                    key="upload"
                    type="primary"
                    onClick={handleUpload}
                    loading={loading}
                    disabled={fileList.length === 0}
                >
                    Upload
                </Button>,
            ]}
            width={600}
        >
            <Dragger {...uploadProps}>
                <p className="ant-upload-drag-icon">
                    <UploadOutlined />
                </p>
                <p className="ant-upload-text">Click or drag video file to this area to upload</p>
                <p className="ant-upload-hint">
                    Support for MP4, AVI, MOV, WMV, FLV, WEBM files <br />
                    File size should be less than 50MB
                </p>
            </Dragger>
            {loading && <Progress percent={Math.round(uploadProgress)} />}
        </Modal>
    );
};

export default UploadModal; 